// Persist
import {
  dbReducer,
  ReduxChange,
  ReduxFindAll,
  ReduxInsert,
  ReduxRemove,
} from '@weblite/persist'

const COLLECTION = 'openedRoomPinnedMessages'

export const openedRoomPinnedMessagesStorage = {
  deleteAll() {
    ReduxRemove(COLLECTION, {})
  },

  getAll(): number[] {
    return ReduxFindAll(COLLECTION)
  },

  deleteMessages(iids: number[]) {
    ReduxRemove(COLLECTION, iids)
  },

  replace(iids: number[]) {
    ReduxChange(COLLECTION, iids)
  },

  insert(iid: number) {
    ReduxInsert(COLLECTION, iid)
  },
}

export const openedRoomPinnedMessagesReducer = dbReducer(['main', COLLECTION])
